import { useMemo } from 'react'
import { useAuth } from '../context/AuthProvider'
import {
  canActInCanton,
  canActOnAnyTenant,
  canUpdateTree,
  canViewTreeDetail,
  getPermittedTenants,
  getPreferredCantonSlug,
  TREE_PERMISSION,
} from '../utils/treePermissions'

/**
 * Permisos de la sesión actual sobre árboles y tenants, ligados a useAuth.
 * La lógica vive en utils/treePermissions (funciones puras); este hook solo aporta la sesión.
 */
export const useTreePermissions = () => {
  const { isAuthenticated, isAdmin, assignedTenants } = useAuth()

  return useMemo(() => {
    const session = {
      isAuthenticated: Boolean(isAuthenticated),
      isAdmin: Boolean(isAdmin),
      assignedTenants,
    }

    return {
      canViewTreeDetail: tenantRef => canViewTreeDetail(session, tenantRef),
      canUpdateTree: tenantRef => canUpdateTree(session, tenantRef),
      canActInCanton: (permission, cantonSlug) => canActInCanton(session, permission, cantonSlug),
      getPreferredCantonSlug: permission => getPreferredCantonSlug(assignedTenants, permission),
      getPermittedTenants: (cantonTenants, permission) =>
        getPermittedTenants(session, cantonTenants, permission),
      canRegisterAnyTenant: canActOnAnyTenant(session, TREE_PERMISSION.REGISTER),
      canUpdateAnyTenant: canActOnAnyTenant(session, TREE_PERMISSION.UPDATE),
    }
  }, [isAuthenticated, isAdmin, assignedTenants])
}
